<template>
  <div class="book-entries-wrapper">
    <template v-if="canVerb(resource, 'index')">
      <b-overlay center :show="!isLoading && !hasFilterLoaded" rounded="sm">
        <actions-toolbar>
          <template #filters>
            <div class="status-filter">
              <!-- <p style="display: flex; align-items: center; gap: 5px">
              <span style="font-size: 14px; font-weight: 500">Filtri</span
              ><svg
                xmlns="http://www.w3.org/2000/svg"
                viewBox="0 0 1024 1024"
                width="18"
              >
                <path
                  d="M960 682.7H527.3c-9.7 0-18.2-6.6-20.7-16-16.5-64.2-74.6-112-144-112s-127.6 47.8-144 112c-2.4 9.4-10.9 16-20.7 16H64c-11.8 0-21.3 9.6-21.3 21.3h0c0 11.8 9.6 21.3 21.3 21.3h134c9.7 0 18.2 6.6 20.7 16 16.5 64.2 74.6 112 144 112s127.6-47.8 144-112c2.4-9.4 10.9-16 20.7-16h432.7c11.8 0 21.3-9.6 21.3-21.3h0c0-11.8-9.6-21.3-21.3-21.3zm-597.3 128c-58.9 0-106.6-47.8-106.6-106.7s47.7-106.6 106.6-106.6 106.6 47.8 106.6 106.7-47.7 106.6-106.6 106.6zm298.6-341.4c69.4 0 127.6-47.8 144-112 2.4-9.4 10.9-16 20.7-16h134c11.8 0 21.3-9.6 21.3-21.3h0c0-11.8-9.6-21.3-21.3-21.3H826c-9.7 0-18.2-6.6-20.7-16-16.5-64.2-74.6-112-144-112s-127.6 47.8-144 112c-2.4 9.4-10.9 16-20.7 16H64c-11.8 0-21.3 9.6-21.3 21.3h0c0 11.8 9.6 21.3 21.3 21.3h432.7c9.7 0 18.2 6.6 20.7 16 16.5 64.2 74.6 112 144 112h0zm0-256c58.9 0 106.7 47.8 106.7 106.7s-47.8 106.7-106.7 106.7S554.6 378.9 554.6 320s47.8-106.7 106.7-106.7h0z"
                ></path>
              </svg>
            </p> -->
              <!-- <pre>{{ activeFilters }}</pre> -->
              <!-- v-for="(value, name, index) in computeActiveFilters" -->
              <div class="pill-wrapper my-3">
                <span
                  class="pill"
                  v-for="(value, name, index) in activeFilters"
                  :key="index"
                  data-color="white"
                >
                  <span v-b-toggle.sidebar-1 :data-filter="name"
                    ><strong>{{ sidebarFilterName(name, context) }}</strong
                    >:&nbsp;{{ sidebarFilterValue(name, value) }}</span
                  >
                  <span tabindex="0">
                    <span
                      @click="resetSingleSidebarFilter(name)"
                      title="Rimuovi filtro"
                      >×</span
                    >
                  </span>
                </span>
                <template v-if="countActiveFilters">
                  <span
                    class="pill"
                    data-color="alert"
                    @click="resetAllFilters()"
                    title="Rimuovi i filtri e apri il pannello per una nuova ricerca"
                  >
                    <span
                      ><strong
                        >Reset ({{ countActiveFilters }})</strong
                      ></span
                    >
                    <span><span>×</span></span>
                  </span>
                </template>
              </div>
            </div>
          </template>
          <b-button-group
            v-b-toggle.sidebar-1
            :class="`filter-button-group btn--smaller btn--transparent align-items-center gap-3${
              countActiveFilters ? ' active' : ''
            }`"
            :title="getDefaultFilterMessage()"
          >
            <base-icon name="filters" width="23" height="23" />
            <span style="font-size: 14px; font-weight: 500">{{
              computedFilterTitle
            }}</span>
          </b-button-group>
          <export-options
            :exportUrl="exportUrl"
            :repository="repository"
            :resource="resource"
            :tableRef="$refs[tableRef]"
            :filter="filter"
            :options="[
              {
                code: 'EXPOBOEN',
                label: null,
                formats: ['csv', 'pdf'],
              },
              {
                code: 'REGIFOCA',
                label: null,
                formats: ['csv', 'pdf'],
              },
              // {
              //   code: 'INCACOMP2',
              //   label: null,
              //   formats: ['pdf'],
              // },
              {
                code: 'TOTAFOCA',
                label: null,
                formats: ['pdf', 'csv'],
              },
              {
                code: 'FOCACOL',
                label: null,
                formats: ['pdf', 'csv'],
              },
              {
                code: 'FOCALETACC',
                label: null,
                formats: ['pdf', 'csv'],
              },
            ]"
          ></export-options>
          <b-button
            class="btn btn--create btn--smaller"
            type="button"
            variant="primary"
            size="sm"
            @click="onAdd"
            title="Crea un movimento di Foglio Cassa"
            v-if="canVerb(resource, 'store')"
          >
            <base-icon name="circled_plus" width="22" height="22" />
            Crea
          </b-button>
          <b-button
            type="button"
            class="btn--smaller btn--transparent"
            variant="secondary"
            size="sm"
            @click="onRefreshContent(filterName)"
            title="Refresh"
            ref="refreshBookEntriesTable"
          >
            <base-icon name="reload" width="20" height="20" />
            Ricarica
          </b-button>
        </actions-toolbar>
        <div class="table-container">
          <b-sidebar
            id="sidebar-1"
            :title="computedFilterTitle"
            :backdrop="true"
            width="50dvw"
            shadow
            right
            :visible="open_filter"
            :data-open="open_filter"
            @change="onSidebarFilterChange"
          >
            <template #header="{ hide }">
              <div class="inner-header">
                <div class="inner-header--create">
                  <strong class="mr-auto">
                    Crea un movimento di Foglio Cassa
                  </strong>
                  <b-button
                    class="btn btn--create btn--smaller"
                    type="button"
                    variant="primary"
                    size="sm"
                    @click="onAdd"
                    title="Crea un movimento di Foglio Cassa"
                    :disabled="!canVerb(resource, 'store')"
                  >
                    <base-icon name="circled_plus" width="16" height="16" />
                    <span>Crea</span>
                  </b-button>
                </div>
                <div class="inner-header--info">
                  <strong class="mr-auto">
                    {{ computedFilterTitle }}
                  </strong>
                  <button class="close text-dark" @click="hide">
                    <b-icon icon="x"></b-icon>
                  </button>
                </div>
              </div>
            </template>
            <b-form @submit.prevent="onSearch(filterName)">
              <div class="filter">
                <div class="filter-item" data-cols="2">
                  <base-input
                    name="number"
                    type="text"
                    label="Numero Polizza"
                    v-model="filter.byCustom.number.value"
                    placeholder="Inserisci un numero polizza"
                    @input="onInputNumberOrRegistry"
                  />
                  <base-input
                    :class="{
                      'filter-item-inner-wrapped': true,
                    }"
                    name="Anagrafica"
                    label="Anagrafica"
                    placeholder="Inserisci un nominativo"
                    v-model="filter.byRegistry.title"
                    @input="onRegistryTitleInput"
                  />
                </div>
                <div class="filter-item" data-cols="2">
                  <base-datepicker
                    name="book_date"
                    label="Data Registrazione dal"
                    v-model="filter.byCalendar.from"
                  />
                  <base-datepicker
                    name="book_date"
                    label="Data Registrazione al"
                    v-model="filter.byCalendar.to"
                  />
                </div>
                <div class="filter-item" data-cols="2">
                  <base-datepicker
                    name="effective_date"
                    label="Data Effetto dal"
                    v-model="filter.byEffectiveness.from"
                  />
                  <base-datepicker
                    name="effective_date"
                    label="Data Effetto al"
                    v-model="filter.byEffectiveness.to"
                  />
                </div>
                <div class="filter-item" data-cols="2">
                  <base-datepicker
                    name="detail_date"
                    label="Data Movimentazione contabile dal"
                    v-model="filter.byDetailDate.from"
                  />
                  <base-datepicker
                    name="detail_date"
                    label="Data Movimentazione contabile al"
                    v-model="filter.byDetailDate.to"
                  />
                </div>
                <div class="filter-item" data-cols="2">
                  <base-select
                    name="insurer_id"
                    label="Compagnia"
                    v-model="filter.byInsurer.id"
                    :options="companies"
                    :taggable="true"
                    :multiple="true"
                    @input="onInputInsurer"
                  />
                  <div>
                    <base-select
                      name="cod_prod"
                      label="Produttore"
                      :options="salesmen_select"
                      v-model="filter.byBrokerEnhanced.salesmen"
                      :multiple="true"
                      :closeOnSelect="false"
                      :taggable="salesmen_taggable"
                      :defaultHtmlMultipleSelect="true"
                      @changeTaggable="changeTaggable"
                    >
                      <template #advanced-actions>
                        <b-button
                          :pressed.sync="myToggle"
                          variant="light"
                          class="btn--smaller btn--x-smaller btn--transparent"
                          @click="
                            myToggle ? selectAllBrokers() : deselectAllBrokers()
                          "
                          >{{
                            myToggle ? "Deseleziona tutti" : "Seleziona tutti"
                          }}
                        </b-button>
                        <b-button
                          :pressed.sync="myTogglePO"
                          variant="light"
                          class="btn--smaller btn--x-smaller btn--transparent"
                          @click="
                            myTogglePO
                              ? salesmenOrderByCode()
                              : salesmenOrderByName()
                          "
                          >{{
                            myTogglePO ? "Ordine per nome" : "Ordina per codice"
                          }}
                        </b-button>
                      </template>
                    </base-select>
                  </div>
                </div>
                <div class="filter-item" data-cols="3">
                  <base-select
                    name="Ramo"
                    label="Ramo"
                    :options="risk_branches"
                    v-model="filter.byRiskBranch.id"
                    :multiple="true"
                    :taggable="true"
                    :closeOnSelect="false"
                    @input="onInputBranch"
                  />
                  <base-select
                    name="Prodotto"
                    label="Prodotto"
                    :options="products"
                    v-model="filter.byInsuranceRisk.id"
                    :taggable="true"
                    :multiple="true"
                    :closeOnSelect="false"
                  />
                  <base-select
                    name="treasury_id"
                    label="Forme di Pagamento"
                    v-model="filter.byTreasury.id"
                    :taggable="true"
                    :multiple="true"
                    :closeOnSelect="false"
                    :options="treasuries"
                  />
                </div>
                <div class="filter-item" data-cols="2">
                  <base-select
                    name="broker_statement"
                    label="Stato Rendicontale"
                    v-model="filter.byBrokerStatement.id"
                    :options="opt_broker_statement"
                    :taggable="false"
                    :multiple="false"
                    :closeOnSelect="true"
                  />
                  <base-input
                    name="sheet_number"
                    type="text"
                    label="Numero Foglio Cassa"
                    v-model="filter.byAttribute.sheet_number"
                    placeholder="Inserisci un numero di FC Progressivo"
                  />
                </div>
                <div class="filter-item" data-type="registry-group">
                  <div>
                    <b-button-toolbar>
                      <b-button-group>
                        <base-input
                          :class="{
                            'filter-item-inner-wrapped': true,
                          }"
                          name="Gruppo Anagrafico"
                          label="Gruppo Anagrafico"
                          v-model="form.inpt_label_group"
                          :readonly="true"
                        />
                        <b-button
                          class="btn-quick btn--light"
                          size="sm"
                          text="Button"
                          variant="lisaweb"
                          title="Cerca gruppo anagrafico"
                          @click="openQuickSearchGroup"
                        >
                          <!-- <b-icon icon="search"></b-icon> -->
                          <base-icon
                            name="search"
                            width="14"
                            height="14"
                          ></base-icon>
                        </b-button>
                        <b-button
                          v-if="form.inpt_label_group"
                          class="btn--light btn--alert"
                          size="sm"
                          text="Button"
                          variant="lisaweb"
                          @click="resetGroupId"
                          title="Elimina gruppo anagrafico"
                        >
                          <!-- <base-icon name="trash" width="22" height="22"></base-icon> -->
                          <base-icon
                            name="trash"
                            width="22"
                            height="22"
                          ></base-icon>
                        </b-button>
                      </b-button-group>
                    </b-button-toolbar>
                  </div>
                </div>
                <quick-search-group-modal
                  ref="quickSearchGroup"
                  @input="handleGroupModalInput"
                ></quick-search-group-modal>
                <div class="filter-item" data-type="registry-group-info">
                  <div
                    class="details-card-wrapper"
                    v-if="extra_group_full_info"
                  >
                    <b-card>
                      <div
                        slot="header"
                        class="d-flex justify-content-between align-items-center"
                      >
                        <p class="mb-0 d-inline-block align-middle">
                          <strong
                            >Informazioni gruppo anagrafico selezionato</strong
                          >
                        </p>
                      </div>
                      <div
                        class="custom-grid-wrapper"
                        v-html="extra_group_full_info"
                      ></div>
                    </b-card>
                  </div>
                </div>

                <h3 class="inner-filter-title mt-5">Filtri aggiuntivi</h3>
                <div class="filter-item">
                  <base-select
                    name="cooperators"
                    label="Collaborazioni"
                    v-model="filter.byBrokerEnhanced.cooperators"
                    :options="cooperators"
                    :taggable="true"
                    :multiple="true"
                    :closeOnSelect="false"
                  />
                </div>
                <div class="filter-item" data-cols="3">
                  <base-select
                    name="book_tags"
                    label="Codice Documento"
                    v-model="filter.byBookTag.id"
                    :taggable="true"
                    :multiple="true"
                    :closeOnSelect="false"
                    :options="book_tags_opt"
                  />
                  <base-input
                    name="note"
                    type="text"
                    label="Nota"
                    v-model="filter.byTask.description"
                    placeholder="Inserisci una nota"
                  />
                  <base-input
                    name="REPL"
                    type="text"
                    label="Targa"
                    v-model="filter.byInsurancePolicy.REPL"
                    placeholder="Inserisci una targa"
                  />
                </div>
                <div class="filter-item" data-cols="3">
                  <base-datepicker
                    name="sheet_date"
                    label="Data registrazione Foglio Cassa dal"
                    v-model="filter.bySheetDate.from"
                  />
                  <base-datepicker
                    name="sheet_date"
                    label="Data registrazione Foglio Cassa al"
                    v-model="filter.bySheetDate.to"
                  />
                  <base-datepicker
                    name="imported_at"
                    label="Data Importazione"
                    v-model="filter.byAttribute.sheet_date"
                  />
                </div>
                <div class="filter-item" data-cols="2">
                  <base-currency
                    name="gross"
                    label="Premio lordo da"
                    v-model="filter.byCurrency.from"
                    :options="{ currency: 'EUR', locale: 'it-IT' }"
                    placeholder="Inserisci un premio lordo"
                  />
                  <base-currency
                    name="gross"
                    label="Premio lordo a"
                    v-model="filter.byCurrency.to"
                    :options="{ currency: 'EUR', locale: 'it-IT' }"
                    placeholder="Inserisci un premio lordo"
                  />
                </div>
                <div class="filter-item" data-cols="2">
                  <base-currency
                    name="net"
                    label="Premio netto da"
                    v-model="filter.byNet.from"
                    :options="{ currency: 'EUR', locale: 'it-IT' }"
                    placeholder="Inserisci un premio netto"
                  />
                  <base-currency
                    name="net"
                    label="Premio netto a"
                    v-model="filter.byNet.to"
                    :options="{ currency: 'EUR', locale: 'it-IT' }"
                    placeholder="Inserisci un premio netto"
                  />
                </div>
                <div class="filter-item">
                  <base-checkbox
                    name="statement_anomaly"
                    groupLabel=""
                    label="Solo movimenti con anomalie provvigionali"
                    v-model="filter.byStatementAnomaly"
                    :chk_val="1"
                    :unchk_val="null"
                  />
                </div>
                <div v-show="customFilters.length > 0">
                  <p>Attributi personalizzati</p>

                  <b-row v-for="(element, index) in customFilters" :key="index">
                    <custom-filter
                      v-model="filter.byAttribute[element.key]"
                      :element="element"
                    />
                  </b-row>
                </div>
              </div>
              <div class="actions-filter-sidebar-wrapper">
                <b-button
                  type="submit"
                  variant="lisaweb"
                  size="sm"
                  v-b-toggle:sidebar-1
                  >Cerca
                </b-button>
                <b-button
                  class="btn--transparent btn-reset"
                  type="button"
                  size="sm"
                  @click="onClearFilter(filterName)"
                  >Reset
                </b-button>
              </div>
            </b-form>
          </b-sidebar>

          <!-- <button-group-table
        @csv="onExport('csv')"
        @pdf="openReportModal('INCACOMP2')"
        :options="{
          CSV: { enabled: true },
          PDF: { enabled: true },
        }"
      ></button-group-table> -->
          <!-- REVIEW story-36-a: enable this when BE can handle sort requests!!! -->
          <!-- sortField="book_date" -->
          <book-entries
            @edit="onEdit"
            @destroy="onDestroy"
            @manualFetch="manualFetch"
            :fields="fields"
            :repository="repository"
            :resource="resource"
            :performedSearch="computePerformedSearch"
            :filterCount="countActiveFilters"
            :filterOn="{
              byRelations: [
                'byBroker',
                'byDocument',
                'byTask',
                'byRegistry',
                'byInsurer',
                'byInsuranceAncillary',
                'byVariousAccounting',
                'byBookTag',
                'byInsurerAccounting',
                'byBreakdown',
                'byInsurerParticipant',
                'byBrokerStatement',
              ],
            }"
            :filterName="filterName"
            :ref="tableRef"
            :hasChecksButtonGroup="false"
            :onlyActions="['infomodal', 'destroy', 'edit']"
            sortField="book_date"
          ></book-entries>
        </div>
        <template #overlay>
          <div class="text-center">
            <div class="custom-loader"></div>
            <!-- <base-icon name="loading" width="35" height="35" /> -->
            <p id="cancel-label">Operazione in corso...</p>
          </div>
        </template>
      </b-overlay>
    </template>
    <div v-else class="mt-3">
      <b-icon icon="info-circle" scale="1.00"></b-icon>
      Non hai i permessi
    </div>
  </div>
</template>

<script>
import BookEntries from "@/components/tables/BookEntries";
import BaseIcon from "@/components/BaseIcon";
import BaseCurrency from "@/components/form/BaseCurrency";
import BaseCheckbox from "@/components/form/BaseCheckbox";
import BaseInput from "@/components/form/BaseInput";
// import ButtonGroupTable from "@/components/ButtonGroupTable";
import ExportOptions from "@/components/ExportOptions";
import BaseSelect from "@/components/form/BaseSelect";
import BaseDatepicker from "@/components/form/BaseDatepicker";
import CustomFilter from "@/components/form/CustomFilter";
import CustomFiltersMixin from "@/mixins/CustomFiltersMixin";
import StorageGetterMixin from "@/mixins/StorageGetterMixin";
import { RepositoryFactory } from "@/repositories/RepositoryFactory";
import { mapGetters, mapActions } from "vuex";
import QuickSearchGroupModal from "@/components/modals/quickSearchGroup";
import { toLocaleCurrency } from "@/utils/strings";
import { toLocaleDate } from "@/utils/dates";
import { toInfoData } from "@/utils/transforms";
import SidebarFilterMixin from "../../../mixins/SidebarFilterMixin";
// import ExportsMixin from "@/mixins/ExportsMixin";
// import submitReportModal from "@/components/modals/submitReportModal";
// import ReportsMixin from "@/mixins/ReportsMixin";

export default {
  mixins: [
    CustomFiltersMixin,
    SidebarFilterMixin,
    StorageGetterMixin /* , ExportsMixin, ReportsMixin */,
  ],
  data() {
    return {
      exportUrl: null,
      filter: this.initFilter(),
      hasFilterLoaded: false, // use when there are default values coming from api call
      filterName: "filterBookEntry",
      resource: "book_entries",
      context: "book_entries",
      repository: "book_entry",
      tableRef: "BookEntryTableRef",
      activeFilters: {},
      performedSearch: false,
      salesmen: [],
      salesmen_ids: [],
      salesmen_ordered: [],
      salesmen_select: [],
      salesmen_taggable: true,
      myToggle: false,
      myTogglePO: false,
      cooperators: [],
      risk_branches: [],
      companies: [],
      products: [],
      risks: [],
      treasuries: [],
      book_tags_opt: [],
      notes: [],
      documents: [],
      opt_broker_statement: [
        { value: "!0", text: "Rendicontato" },
        { value: "!", text: "Non rendicontato" },
      ],
      group_data: null,
      extra_group_full_info: null,
      form: {
        inpt_label_group: "",
        quick_value: "",
      },
      fields: [
        {
          key: "book_date",
          label: this.getDictionary("book_date", "book_entry"),
          sortable: true,
          formatter: (value) => toLocaleDate(value),
          sortKey: "book_date",
        },
        {
          key: "effective_date",
          label: this.getDictionary("effective_date", "book_entry"),
          sortable: true,
          formatter: (value) => toLocaleDate(value),
          sortKey: "effective_date",
        },
        {
          key: "document_code",
          label: this.getDictionary("code", "book_tag"),
        },
        {
          key: "insurer.display",
          label: this.getDictionary("insurer_id", "book_entry"),
          sortable: true,
          sortKey: "byInsurer.display",
        },
        {
          key: "branch",
          label: this.getDictionary("title", "risk_branch"),
          sortable: true,
          sortKey: "byRiskBranch.title",
        },
        {
          key: "product",
          label: this.getDictionary("insurance_risk"),
          sortable: true,
          sortKey: "byInsuranceRisk.title",
        },
        {
          key: "insurance_policy_number",
          label: this.getDictionary("insurance_policy_number", "book_entry"),
          sortable: true,
          sortKey: "byInsurancePolicy.number",
        },
        {
          key: "customer",
          label: this.getDictionary("registry", "book_entry"),
          sortable: true,
          sortKey: "byRegistry.title",
        },
        {
          key: "gross",
          label: this.getDictionary("gross", "book_entry"),
          formatter: (value) => toLocaleCurrency(value),
          tdClass: "text-right",
          thClass: "text-right",
          sortable: true,
        },
        {
          key: "agency_gross",
          label: this.getDictionary("agency_gross"),
          tdClass: "text-right",
          thClass: "text-right",
        },
        {
          key: "saler_gross",
          label: this.getDictionary("saler_gross"),
          tdClass: "text-right",
          thClass: "text-right",
        },
        {
          key: "cooperator",
          label: this.getDictionary("cooperator"),
          sortable: true,
          sortKey: "byBroker.BUID",
          thClass: "col-width",
          tdClass: "col-width",
        },
        {
          key: "broker",
          label: this.getDictionary("broker", "book_entry"),
          sortable: true,
          sortKey: "byBroker.BUID",
          thClass: "col-width",
          tdClass: "col-width",
        },
        {
          key: "note_counter",
          label: this.getDictionary("note"),
        },
        {
          key: "document_counter",
          label: this.getDictionary("document"),
        },
        {
          key: "broker_statement_id",
          label: this.getDictionary("broker_statement_id"),
        },
      ],
    };
  },
  components: {
    BaseIcon,
    BaseInput,
    // ButtonGroupTable,
    ExportOptions,
    BaseSelect,
    BaseDatepicker,
    BookEntries,
    BaseCurrency,
    BaseCheckbox,
    CustomFilter,
    QuickSearchGroupModal,
    // submitReportModal,
  },
  methods: {
    toInfoData,
    changeTaggable(val) {
      this.salesmen_taggable = val;
    },
    salesmenOrderByName() {
      this.salesmen_select = this.salesmen;
    },
    salesmenOrderByCode() {
      this.salesmen_select = this.salesmen_ordered;
    },
    selectAllBrokers() {
      this.filter.byBrokerEnhanced.salesmen = this.getSalesmen().map(
        (cooperator) => cooperator.value,
      );
    },
    deselectAllBrokers() {
      this.filter.byBrokerEnhanced.salesmen = [];
      this.salesman_id = null;
    },
    manualFetch() {
      this.resetAllFilters();
    },
    resetAllFilters() {
      this.onClearFilter(this.filterName);
      // this.activeFilters = {};
      this.exportUrl = null;
      const table = this.tableRef ? this.$refs[this.tableRef] : null;
      if (table) {
        table.items = [];
        table.totalRows = 0;
      }
      this.open_filter = true;
    },
    retriveActiveFilters(obj = this.filter, parentKey = "") {
      for (const key in obj) {
        const value = obj[key];
        // Build the property path (for nested properties)
        const fullPath = parentKey ? `${parentKey}.${key}` : key;

        if (key === "byCustom" && typeof value === "object") {
          // Special handling for `byCustom`: Return everything in the inner object only if `value` is not null
          for (const innerKey in value) {
            const innerValue = value[innerKey];
            if (
              innerValue &&
              typeof innerValue === "object" &&
              "value" in innerValue
            ) {
              /* By default "value" is euqal to `null`, after it's been filled and being consequently emptied it's equal to an empty string */
              if (!(innerValue.value === null || innerValue.value === "")) {
                this.activeFilters[`${fullPath}.${innerKey}.value`] =
                  innerValue.value;
              }
            }
          }
        } else if (value && Array.isArray(value)) {
          if (value.length === 1) {
            this.activeFilters[fullPath] = value[0];
          } else if (value.length > 1) {
            // If it's an array don't print all the values recorsively
            this.activeFilters[fullPath] = `${value.length} selezioni`;
          }
        } else if (value && typeof value === "object") {
          // Recursively process nested objects for non-`byCustom` keys
          Object.assign(
            this.activeFilters,
            this.retriveActiveFilters(value, fullPath),
          );
        } else if (value !== null && String(value).length) {
          // Append non-null values
          this.activeFilters[fullPath] = value;
        }
      }

      delete this.activeFilters["byView"];

      return this.activeFilters;
    },
    onRegistryTitleInput() {
      this.filter.byRegistry.id = null;
      this.onInputNumberOrRegistry();
    },
    initFilter() {
      let init = {
        byAttribute: {
          title: null,
          year: null,
          contractor: null,
          book_date: null,
          sheet_date: null,
          sheet_number: null,
          gross: null,
        },
        byView: "book_entry",
        byCalendar: {
          from: null,
          to: null,
        },
        byEffectiveness: {
          from: null,
          to: null,
        },
        byDetailDate: {
          from: null,
          to: null,
        },
        bySheetDate: {
          from: null,
          to: null,
        },
        byTreasury: {
          id: null,
        },
        byBookTag: {
          id: null,
        },
        byBrokerEnhanced: {
          salesmen: [],
          cooperators: [],
        },
        byRegistry: {
          id: null,
          title: null,
        },
        byCustom: {
          number: {
            value: null,
            likewise: 0,
            filter: "byInsurancePolicy",
          },
        },
        byRegistryGroup: {
          code: null,
        },
        byInsurer: {
          id: null,
        },
        byCurrency: {
          to: null,
          from: null,
        },
        byNet: {
          from: null,
          to: null,
        },
        byInsuranceRisk: {
          id: null,
        },
        byRiskBranch: {
          id: null,
        },
        byRiskType: {
          id: null,
        },
        byBrokerStatement: {
          id: null,
        },
        byInsurancePolicy: {
          REPL: null,
        },
        byTask: {
          description: null,
        },
        byStatementAnomaly: null,
      };
      return init;
    },
    onInputNumberOrRegistry() {
      this.filter.byCalendar.from =
        this.filter.byCalendar.from &&
        this.filter.byCalendar.from != this.lastCreated
          ? this.filter.byCalendar.from
          : this.filter.byCustom.number.value || this.filter.byRegistry.title
          ? null
          : this.lastCreated;
      this.filter.byCalendar.to =
        this.filter.byCalendar.to &&
        this.filter.byCalendar.to != this.lastCreated
          ? this.filter.byCalendar.to
          : this.filter.byCustom.number.value || this.filter.byRegistry.title
          ? null
          : this.lastCreated;
    },
    onInputInsurer(insurer) {
      this.filter.byInsurer.id = insurer;
      this.filter.byRiskBranch.id = null;
      this.risk_branches = this.getBranches()(insurer);
      this.filter.byInsuranceRisk.id = null;
      this.products = this.getProducts()(
        this.filter.byInsurer.id,
        this.filter.byRiskBranch.id,
        this.filter.byRiskType.id,
      );
    },
    onInputBranch(branches) {
      if (!branches.length) {
        this.filter.byRiskBranch.id = null;
      }
      this.filter.byInsuranceRisk.id = null;
      this.products = this.getProducts()(
        this.filter.byInsurer.id,
        branches,
        this.filter.byRiskType.id,
      );
    },
    onInputRisk(risks) {
      if (!risks.length) {
        this.filter.byRiskType.id = null;
      }
      this.filter.byInsuranceRisk.id = null;
      this.products = this.getProducts()(
        this.filter.byInsurer.id,
        this.filter.byRiskBranch.id,
        risks,
      );
    },
    resetRegistryId() {
      this.filter.byRegistry.id = null;
      this.filter.byRegistry.title = null;
      this.onInputNumberOrRegistry();
    },
    handleGroupModalInput(value) {
      this.filter.byRegistryGroup.code = value.code;
      this.group_data = value;
      this.form.inpt_label_group = this.toInfoData(
        this.group_data,
        "registry_group",
      );
      this.extra_group_full_info = this.toInfoData(
        this.group_data,
        "registry_group_full",
        null,
        "",
      );
      this.$bvModal.hide("quickSearchGroupModal");
    },
    openQuickSearchGroup() {
      this.filter.byRegistryGroup.code = null;
      this.$bvModal.show("quickSearchGroupModal");
    },
    resetGroupId() {
      this.group_data = null;
      this.form.inpt_label_group = null;
      this.filter.byRegistryGroup.code = null;
      this.extra_group_full_info = null;
    },
    onAdd() {
      this.$router.push({
        name: `${this.resource}.create`,
        params: { id: null, item: null, type: "create" },
      });
    },
    customFilterName(key, prefix = "byAttribute") {
      return `${prefix}.${key}`;
    },
    onEdit(item, onlyEditBroker = false) {
      this.$router.push({
        name: `${this.resource}.edit`,
        params: {
          id: `${item.id}`,
          item: item,
          mode: "I",
          type: "edit",
          onlyEditBroker: onlyEditBroker,
        },
      });
    },
    onDestroy(id) {
      const Repo = RepositoryFactory.get(this.repository);
      Repo.destroy(id)
        .then(() => {
          // console.debug("successfully deleted!");
          this.$refs[this.tableRef].fetch();
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
        });
    },
    openPdfModal() {
      this.$bvModal.show("submitReportModal");
    },
    onRefreshContent(name) {
      let criteria = this.filter;
      this.saveFilterByName({ name, criteria });
      this.onSearch(this.filterName);
    },
    onSearch(name) {
      this.performedSearch = true;
      this.activeFilters = {};
      this.activeFilters = this.retriveActiveFilters();
      let criteria = this.filter;
      this.saveFilterByName({ name, criteria });
      let extra_info = this.extra_group_full_info;
      this.saveFilterExtraGroupByName({ name, extra_info });
      this.exportUrl = this.$refs[this.tableRef].loadFilter(
        this.$refs[this.tableRef].filterName,
      );
      // quicksearch
      criteria = {};
      ["quickSearchGroup"].forEach((element) => {
        criteria[element] = {
          label: "",
          formLabel: "",
          data: null,
          formData: null,
        };
      });
      criteria.quickSearchGroup.label = this.form.inpt_label_group;
      criteria.quickSearchGroup.formLabel = "form.inpt_label_group";
      criteria.quickSearchGroup.data = this.group_data;
      criteria.quickSearchGroup.formData = "group_data";
      this.saveQuickSearchByName({ name, criteria });
      this.removePaginationByName(name);
      this.$refs[this.tableRef].currentPage = 1;
      this.$refs[this.tableRef].fetch();
    },
    onClearFilter(name) {
      this.resetRegistryId();
      this.resetGroupId();
      //this.resetPolicyId();
      this.resetFilter();
      // this.resetQuickSearch(); // dovrebbero bastare reset*id()
      this.resetPagination();
      this.removeFilterByName(name);
      this.removeQuickSearchByName(name);
      this.removePaginationByName(name);
      this.removeSortByName(name);
      // this.getLastCreated();
      this.getLastCreated()
        .then(() => {
          // se non c'è già un filtro salvato, imposto i valori di default a byCalendar
          // let found = this.loadFilter(this.filterName);
          // if (!found) {
          this.filter.byCalendar.from = this.lastCreated;
          this.filter.byCalendar.to = this.lastCreated;
          this.activeFilters = {};
          this.activeFilters = this.retriveActiveFilters();
          delete this.activeFilters["byCalendar.from"];
          delete this.activeFilters["byCalendar.to"];
          // }
          // this.formLoaded = true;
        })
        .catch(() => {});
      let criteria = this.filter;
      this.saveFilterByName({ name, criteria });
      this.$refs[this.tableRef].sortBy = "book_date";
      this.$refs[this.tableRef].sortDesc = false;
      // this.onSearch(name);
    },
    getLastCreated() {
      const Repo = RepositoryFactory.get("book_entry");
      this.hasFilterLoaded = false;
      return Repo.index("byLastCreated&byView=book_entry")
        .then((response) => {
          this.lastCreated =
            response.data && response.data.data.length
              ? response.data.data[0].last_created
              : null;
          // this.filter.byCalendar.from = this.lastCreated;
          // this.filter.byCalendar.to = this.lastCreated;
          this.hasFilterLoaded = true;
        })
        .catch((error) => {
          let errMsg = this.$getErrorMessage(error);
          this.$showSnackbar({
            preset: "error",
            text: `${errMsg}`,
          });
          this.hasFilterLoaded = false;
        });
    },
    ...mapActions("filters", {
      saveFilterByName: "saveByName",
      removeFilterByName: "removeByName",
      saveFilterExtraGroupByName: "saveExtraGroupByName",
    }),
    ...mapActions("quicksearch", {
      saveQuickSearchByName: "saveByName",
      removeQuickSearchByName: "removeByName",
    }),
    ...mapActions("pagination", { removePaginationByName: "removeByName" }),
    ...mapActions("sorts", {
      removeSortByName: "removeByName",
    }),
    onSaveFilter(name, criteria) {
      this.saveFilterByName({ name, criteria });
    },
    ...mapGetters("auth", {
      getInsurers: "insurers",
      getBranches: "branches",
      getRisks: "risks",
      getProducts: "products",
      getSalesmen: "salesmen",
      getSalesmenOrderedByCode: "salesmen_orderd_by_code",
      getCooperators: "cooperators",
      getTreasuries: "treasuries",
      getBookTags: "book_tags",
    }),
  },
  mounted() {
    this.companies = this.getInsurers();
    // this.cooperators = this.getCooperators();
    this.risk_branches = this.getBranches()(this.filter.byInsurer.id);
    this.risks = this.getRisks();
    this.salesmen = this.getSalesmen();
    this.salesmen_select = this.getSalesmen();
    this.salesmen_ordered = this.getSalesmenOrderedByCode();
    this.treasuries = this.getTreasuries()([]);
    // this.book_tags_opt = this.getBookTags();
    this.activeFilters = {};
    this.activeFilters = this.retriveActiveFilters();
  },
  beforeMount() {
    this.salesmen = this.getSalesmen();
    this.salesmen_ordered = this.getSalesmenOrderedByCode();
    this.salesmen_select = this.salesmen;
    const path = "auth/";
    const resources = [];
    if (!this.hasLoadedResource("mandate_codes"))
      resources.push(
        this.$store
          .dispatch(`${path}mandate_codes`)
          .then(() => {})
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
      );
    if (!this.hasLoadedResource("book_tags")) {
      resources.push(
        this.$store
          .dispatch(`${path}book_tags`)
          .then(() => {})
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
      );
    } else {
      this.book_tags_opt = this.getBookTags();
    }
    if (!this.hasLoadedResource("cooperators")) {
      resources.push(
        this.$store
          .dispatch(`${path}cooperators`)
          .then(() => {})
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
      );
    } else {
      this.cooperators = this.getCooperators();
    }
    if (!this.hasLoadedResource("agency_brokers"))
      resources.push(
        this.$store
          .dispatch(`${path}agency_brokers`)
          .then(() => {})
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
      );
    if (resources.length) {
      this.getResources(resources)
        .then(() => {
          this.cooperators = this.getCooperators();
          this.book_tags_opt = this.getBookTags();
          this.isLoading = false;
        })
        .catch((error) => {
          console.log("One or more promises crashed... :|");
          this.onFailure(error);
        })
        .finally(() => {
          // this.unloadMsg();
          this.isLoading = false;
        });
    } else {
      this.isLoading = false;
    }
    this.getLastCreated()
      .then(() => {
        // se non c'è già un filtro salvato, imposto i valori di default a byCalendar
        let found = this.loadFilter(this.filterName);
        if (!found) {
          // this.$set(this, "filter", this.initFilter());
          // this.filter.byCalendar.from = this.lastCreated;
          // this.filter.byCalendar.to = this.lastCreated;
          // this.$set(this.filter.byCalendar, "from", this.lastCreated);
          // this.$set(this.filter.byCalendar, "to", this.lastCreated);
          this.filter.byCalendar.from = this.lastCreated;
          this.filter.byCalendar.to = this.lastCreated;
          this.activeFilters = {};
          this.activeFilters = this.retriveActiveFilters();
          this.open_filter = true;
        } else if (
          JSON.stringify(this.initFilter()) !== JSON.stringify(found)
        ) {
          this.onSearch(this.filterName);
        } else {
          /* Default values at 2nd render - DO NOTHING */
          // this.$set(this, "filter", found);
        }
      })
      .catch(() => {});
  },
  // beforeDestroy() {
  //   this.onClearFilter(this.filterName);
  //   /* Fix navigazione all'interno del modulo CONT */
  //   const filterName = "filterRegistryGroup";
  //   this.removeFilterByName(filterName);
  //   this.removePaginationByName(filterName);
  //   this.removeSortByName(filterName);
  // },
  computed: {
    countActiveFilters() {
      console.log("COUNT ACT FILTERS", Object.keys(this.activeFilters));
      return Object.keys(this.activeFilters).length;
    },
    computePerformedSearch() {
      return this.performedSearch;
    },
    computedFilterTitle() {
      return `Filtri${
        this.countActiveFilters ? ` (${this.countActiveFilters})` : ""
      }`;
    },
    agencyHasFee() {
      return this.$store.state.auth.use_fee === "Y" ? true : false;
    },
  },
  created() {
    this.isLoading = false;
    if (this.agencyHasFee) {
      const feeGrossField = {
        key: "fee_gross",
        label: this.getDictionary("fee_gross", "book_entry"),
        formatter: (value) => toLocaleCurrency(value),
        sortable: true,
        thClass: "text-right",
        thStyle: {
          "text-align": "right",
        },
        tdClass: "text-right",
      };
      this.fields.splice(9, 0, feeGrossField);
    }
    /* Commented out because of the import of quickSearchRegistry */
    /* */
    // console.log("beforeCreate index");
    const path = "auth/";
    const resources = [];
    if (!this.hasLoadedResource("councils"))
      //   // this.getResources("auth/councils");
      //   // resources.push({
      //   //   path: path,
      //   //   value: "councils",
      //   // });
      resources.push(
        this.$store
          .dispatch(`${path}councils`)
          .then(() => {
            console.info(`background data "${path}councils" fetched correctly`);
          })
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
        // .finally(() => {
        //   this.unloadMsg();
        //   this.isLoading = false;
        // })
      );
    if (!this.hasLoadedResource("provinces"))
      // this.getResources("auth/provinces");
      // resources.push({
      //   path: path,
      //   value: "provinces",
      // });
      resources.push(
        this.$store
          .dispatch(`${path}provinces`)
          .then(() => {
            console.info(
              `background data "${path}provinces" fetched correctly`,
            );
          })
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
        // .finally(() => {
        //   this.unloadMsg();
        //   this.isLoading = false;
        // })
      );
    if (!this.hasLoadedResource("countries")) {
      resources.push(
        this.$store
          .dispatch(`${path}countries`)
          .then(() => {
            console.info(
              `background data "${path}countries" fetched correctly`,
            );
            // const defaultCountryId = this.getCountries().find(
            //   (country) => country.text == this.defaultCountryName
            // ).value;
            // this.opt_provinces = this.getProvinces()(defaultCountryId);
          })
          .catch((error) => {
            let errMsg = this.$getErrorMessage(error);
            this.$showSnackbar({ preset: "error", text: errMsg });
          }),
        // .finally(() => {
        //   this.unloadMsg();
        //   this.isLoading = false;
        // })
      );
    }
    if (resources.length) {
      this.getResources(resources)
        .then(() => {
          console.log("All promises went through correctly");
        })
        .catch((error) => {
          console.log("One or more promises crashed... :|");
          this.onFailure(error);
        })
        .finally(() => {
          this.isLoading = false;
          // this.$emit("storageLoading", false);
        });
    } else {
      this.isLoading = false;
      // this.$emit("storageLoading", false);
    }
    /* */
  },
};
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
.book-entries-wrapper > div[aria-busy="true"] .position-absolute.bg-light {
  top: -10px !important;
}

:deep(.col-width) {
  width: 200px !important;
  min-width: 200px !important;
  max-width: 200px !important;
}
</style>
